const BOOTSTRAP_PROMISE_KEY = '__mibodega_pos_bootstrap_promise__';
const BOOTSTRAP_COMPLETE_KEY = '__mibodega_pos_bootstrap_complete__';

function getBootstrapScope() {
  return globalThis as typeof globalThis & {
    [BOOTSTRAP_PROMISE_KEY]?: Promise<unknown>;
    [BOOTSTRAP_COMPLETE_KEY]?: boolean;
  };
}

export function hasCompletedBootstrap(): boolean {
  return getBootstrapScope()[BOOTSTRAP_COMPLETE_KEY] === true;
}

/** Reuses the local-data bootstrap promise when Vite re-evaluates the entrypoint. */
export function getOrCreateBootstrap<Result>(start: () => Promise<Result>): Promise<Result> {
  const scope = getBootstrapScope();
  const existing = scope[BOOTSTRAP_PROMISE_KEY];
  if (existing !== undefined) {
    return existing as Promise<Result>;
  }

  const promise = Promise.resolve()
    .then(start)
    .then(
      (result) => {
        scope[BOOTSTRAP_COMPLETE_KEY] = true;
        return result;
      },
      (error: unknown) => {
        delete scope[BOOTSTRAP_PROMISE_KEY];
        throw error;
      },
    );
  scope[BOOTSTRAP_PROMISE_KEY] = promise;
  return promise;
}
